// @ts-nocheck
import React, { FC, ReactNode, useEffect, useContext } from "react";
import useIntersect from "../../../utils/Intersect";
import { AnalyticsContext } from "../../../utils/analytics/analytics-context";
import "./section.css";

interface SectionProps {
  children: ReactNode;
  id?: string;
  className?: string;
  wave?: boolean;
}

/**
 * Section
 */
export const Section: FC<SectionProps> = ({
  children,
  className,
  id,
  wave,
}) => {
  const { track } = useContext(AnalyticsContext);
  const [ref, entry] = useIntersect({
    threshold: [0.2],
  });
  useEffect(() => {
    if (entry.intersectionRatio > 0.2) {
      track("page_view", {
        page_title: id,
      });
    }
  }, [entry, id, track]);
  return (
    <section ref={ref} className={`Section ${className || ""}`} id={id}>
      <div className="content" style={{ padding: wave ? "0" : "48px 0" }}>
        {children}
      </div>
    </section>
  );
};
